import styled from 'styled-components'

/**
 * Label treatment for the nav items we are actively promoting: a brand-green
 * icon and a New tag, because a preview nobody notices gets no leads.
 */
export const NavLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--m-spacing-2);
`

export const NewTag = styled.span`
  /* Never let the tag be the thing that gets squeezed. */
  flex: 0 0 auto;
  padding: 0 6px;
  border-radius: 999px;
  font-size: var(--m-font-size-1);
  font-weight: var(--m-font-weight-bold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgb(var(--m-color-primary-100));
  background-color: rgb(var(--m-color-brand));
`
